import React from 'react'

function Inventory() {
  return (
    <>
      <section className="inventory-container">
        <h1 className="inven-H1">
          Inventory
       </h1>
        <input type="text" name="search" placeholder="Search" id="search" className="search" required />
        <input type="text" name="" placeholder="" id="" className="stock1" required />
        <input type="text" name="" placeholder="" id="" className="stock2" required />
        <input type="text" name="" placeholder="" id="" className="stock3" required />
        <input type="text" name="" placeholder="" id="" className="stock4" required />
        <input type="text" name="" placeholder="" id="" className="stock5" required />
        <a className="bth1" href="">Back to Home</a>

      </section>
    </>
  )
}

export default Inventory
